// @flow
import React from "react";
import ReactDOM from "react-dom";
import TVPlayer from "./tvplayer";
import TVWidget from "./tvplayer-widget";

// NAVBAR
window.addEventListener("click", function (event) {
  document.querySelectorAll("details.dropdown[open]").forEach(function (dropdown) {
    if (!dropdown.contains(event.target)) {
      dropdown.removeAttribute("open");
    }
  });
});

// HOMEPAGE VIDEO
const video = document.getElementById("heroVideo");
const video_widget = document.getElementById("video_widget");

if (video) ReactDOM.render(<TVPlayer hlsURL="/hls/hero1/index.m3u8" height="100vh" />, video);
if (video_widget) ReactDOM.render(<TVWidget hlsURL="https://media.indemand.tv/enc/2.0.118/RGLL9BWdBWAVnzZfPq/playlist.m3u8" />, video_widget);

// FAQs
const searchInput = document.getElementById("faq-search");
const items = document.querySelectorAll(".faq-item");
const categories = document.querySelectorAll("h2.faq-category");

searchInput?.addEventListener("input", function () {
  const term = this.value.toLowerCase().trim();

  if (!term) {
    // CLEAR ALL HIDDEN CLASSES
    document.querySelectorAll(".faq-item").forEach((item) => item.classList.remove("hidden"));
    document.querySelectorAll("h2.faq-category").forEach((cat) => cat.classList.remove("hidden"));
    document.querySelectorAll(".faq-group").forEach((group) => group.classList.remove("hidden"));
    return;
  }

  // console.log(term)
  items.forEach((item) => {
    const q = item.dataset.question;
    const a = item.dataset.answer;
    const match = q.includes(term) || a.includes(term);
    // console.log(a, match);
    item.classList.toggle("hidden", !match);
  });

  // Hide categories with no visible items
  // categories.forEach((cat) => {
  //   const group = cat.nextElementSibling;
  //   const visibleItems = group.querySelectorAll(
  //     ".faq-item:not(.hidden)"
  //   ).length;
  //   cat.classList.toggle("hidden", visibleItems === 0);
  //   group.classList.toggle("hidden", visibleItems === 0);
  // });
});
// END FAQs
